import React from "react";
import cx from "./cx";

/**
 * Superficie papel con título en versalitas (Card del bundle del DS).
 *  - title: nodo del título (.rev-card__title); titleAs: etiqueta (h2 por defecto)
 *  - sub: subtítulo bajo el título (.rev-card__sub)
 *  - head: acciones a la derecha del título (envuelve ambos en .rev-card__head)
 *  - foot: pie de la card tras los children (.rev-card__foot, con filete superior);
 *    las acciones del pie van dentro en .rev-card__foot-actions
 *  - el resto de props (data-pendiente, aria-*) van al contenedor
 */
const RevCard = ({ title, titleAs: TitleAs = 'h2', sub, head, foot, className, children, ...rest }) => {
    const titleNode = title !== undefined && title !== null
        ? <TitleAs className="rev-card__title">{title}</TitleAs>
        : null;
    return (
        <div className={cx('rev-card', className)} {...rest}>
            {head
                ? <div className="rev-card__head">{titleNode}{head}</div>
                : titleNode}
            {sub && <p className="rev-card__sub">{sub}</p>}
            {children}
            {foot && <div className="rev-card__foot">{foot}</div>}
        </div>
    );
};

export default RevCard;
